import {
  ArrowUpFromLine,
  BookOpen,
  BrainCircuit,
  CircleHelp,
  Copy,
  FileText,
  PenLine,
} from "lucide-react";
import {
  ONBOARDING_PRIORITY_SELECTION_MAX,
  teachingPrioritiesStepCopy,
  teachingPriorityCenteredOption,
  teachingPriorityOptions,
} from "../../data/onboarding";
import { OnboardingFooter } from "./OnboardingFooter";
import { OnboardingOptionCard } from "./OnboardingOptionCard";
import { OnboardingShell } from "./OnboardingShell";

const PRIORITY_ICONS = {
  "teach-this-topic": BookOpen,
  "explain-differently": PenLine,
  "content-simplifier": ArrowUpFromLine,
  "quick-sheets": FileText,
  "concept-questions": CircleHelp,
  "question-variations": Copy,
  "section-builder": BrainCircuit,
};

function PriorityCard({ option, selected, disabled, onToggle }) {
  const Icon = PRIORITY_ICONS[option.id];
  return (
    <OnboardingOptionCard
      title={option.label}
      icon={Icon}
      selected={selected}
      onClick={() => onToggle(option.id)}
      compact
      disabled={disabled}
    />
  );
}

export function TeachingPrioritiesStep({
  selectedPriorities,
  onTogglePriority,
  onBack,
  onFinish,
}) {
  const selectionCount = selectedPriorities.length;
  const canFinish = selectionCount === ONBOARDING_PRIORITY_SELECTION_MAX;

  function handleToggle(id) {
    const isSelected = selectedPriorities.includes(id);
    if (
      !isSelected &&
      selectionCount >= ONBOARDING_PRIORITY_SELECTION_MAX
    ) {
      return;
    }
    onTogglePriority(id);
  }

  return (
    <OnboardingShell>
      <div className="max-w-4xl">
        <h1 className="text-[32px] font-bold leading-tight text-[#1B1B2F] sm:text-[36px]">
          {teachingPrioritiesStepCopy.title}
        </h1>
        <p className="mt-3 max-w-3xl text-[15px] leading-7 text-[#6B7280]">
          {teachingPrioritiesStepCopy.subtitle}
        </p>
        <p className="mt-2 text-sm font-medium text-[#9A5B2E]">
          {teachingPrioritiesStepCopy.selectionHint(selectionCount)}
        </p>

        <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {teachingPriorityOptions.map((option) => (
            <PriorityCard
              key={option.id}
              option={option}
              selected={selectedPriorities.includes(option.id)}
              disabled={
                !selectedPriorities.includes(option.id) &&
                selectionCount >= ONBOARDING_PRIORITY_SELECTION_MAX
              }
              onToggle={handleToggle}
            />
          ))}
        </div>

        <div className="mt-4 flex justify-center">
          <div className="w-full max-w-xs sm:max-w-sm">
            <PriorityCard
              option={teachingPriorityCenteredOption}
              selected={selectedPriorities.includes(teachingPriorityCenteredOption.id)}
              disabled={
                !selectedPriorities.includes(teachingPriorityCenteredOption.id) &&
                selectionCount >= ONBOARDING_PRIORITY_SELECTION_MAX
              }
              onToggle={handleToggle}
            />
          </div>
        </div>

        <OnboardingFooter
          onBack={onBack}
          onNext={onFinish}
          backLabel={teachingPrioritiesStepCopy.backLabel}
          nextLabel={teachingPrioritiesStepCopy.finishLabel}
          nextDisabled={!canFinish}
          centerMessage={teachingPrioritiesStepCopy.savedMessage}
          finish
        />
      </div>
    </OnboardingShell>
  );
}
